import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import Spinner from "react-webpack-spinner";

class Login extends React.Component {
  render() {
    const { token, logging_in, login_failed, onLogin } = this.props;

    if (token) {
      return (
        <div className="is-fullwidth">
          <Link className="button is-info" to="/logout">
            Abmelden
          </Link>
        </div>
      );
    }

    return (
      <div className="full-width">
        {logging_in ? (
          <div className="single-page-wrapper">
            <h1 className="title">Anmelden</h1>
            <Spinner width={32} height={32} color="black" /> Anmeldung läuft…
          </div>
        ) : (
          <div className="full-height text login">
            <h1 className="title">Anmelden</h1>
            {login_failed && (
              <div className="notification is-danger">Login fehlgeschlagen</div>
            )}
            <form>
              <input className="input" ref="username" placeholder="E-Mail" />
              <input
                className="input"
                type="password"
                ref="password"
                placeholder="Passwort"
              />
              <button
                className="button is-success"
                onClick={() =>
                  onLogin(this.refs.username.value, this.refs.password.value)
                }
              >
                Anmelden
              </button>
            </form>

            <p>
              <Link to="/new-password">Passwort vergessen?</Link>
            </p>
          </div>
        )}
      </div>
    );
  }
}

Login.PropTypes = {
  token: PropTypes.string,
  logging_in: PropTypes.bool,
  login_failed: PropTypes.bool,
  onLogin: PropTypes.func
};

export default Login;



/** WEBPACK FOOTER **
 ** ./src/components/Login.jsx
 **/